import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess } from '../../actions/datasources/createGoal';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';

// Create a suggested goal after a dataset import. Several suggestions can be
// created in parallel, so the slice's response accumulates a per-target-key
// status map: { [target_key]: 'creating' | 'done' | 'failed' }.
const selectStatuses = (state) => state.datasource_create_goal?.response || {};

function* operation(action) {
  const { target_key, goal_type } = action.payload;
  let statuses = yield select(selectStatuses);
  yield put(fetchSuccess({ ...statuses, [target_key]: 'creating' }));
  try {
    yield call(
      axios.post,
      `${config.API_URL}/goals`,
      { target_key, goal_type: goal_type || 'forecast_value' },
      { headers: getLocalUser() },
    );
    statuses = yield select(selectStatuses);
    yield put(fetchSuccess({ ...statuses, [target_key]: 'done' }));
  } catch (error) {
    // Failures surface as the per-button "Retry create goal" state only,
    // exactly like the pre-saga component — no global error dispatch.
    statuses = yield select(selectStatuses);
    yield put(fetchSuccess({ ...statuses, [target_key]: 'failed' }));
  }
}

export function* watch() {
  yield takeEvery(REQUEST, operation);
}
